// When Amex is hidden in the UI, keep any previously stored amex on save and
// never invent one from client defaults.
export function withoutInPersonAmexBucket<T extends { amex?: unknown }>(
  groups: T | undefined
): Omit<T, "amex"> | undefined {
  if (!groups) return groups;
  const { amex: _amex, ...rest } = groups;
  return rest;
}

export function reconcileAmexBucketGroupForSave<T extends { amex?: unknown }>(
  edited: T | undefined,
  stored: T | undefined,
  hideInPersonAmex: boolean
): T | undefined {
  if (!edited || !hideInPersonAmex) return edited;
  if (stored && "amex" in stored && stored.amex != null) {
    return { ...edited, amex: stored.amex };
  }
  return withoutInPersonAmexBucket(edited) as T;
}
